<template>
    <div class="device-warning">
        <div class="public-module-title">
            <img src="@/assets/images/publicTitle.png" alt="">
            <div>设备预警</div>
        </div>

        <div class="table-wrap" @mouseenter="enter" @mouseleave="leave">
            <el-table :data="tableData" height="100%" ref="table">
                <el-table-column prop="deviceName" label="设备" show-overflow-tooltip></el-table-column>
                <el-table-column prop="warnTime" label="时间" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="内容" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div
                            style="color:rgba(0, 255, 242, 1);overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                            {{ scope.row.content }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    data() {
        return {
            timer: null,
            tableData: [
                { deviceName: "土壤墒情8", warnTime: "2024-06-12", content: "氮含量检测值偏低，请及时施肥" },
                { deviceName: "孢子捕捉仪06", warnTime: "2024-05-12", content: "设备断电，请及时检修" },
                { deviceName: "虫情测报四期", warnTime: "2024-05-07", content: "二化螟识别10头，达到日高峰预警" },
                { deviceName: "虫情测报四期", warnTime: "2024-06-19", content: "粘虫识别四头，达到日高峰预警" },
                { deviceName: "杆式气象站四期", warnTime: "2024-06-03", content: "温度过高，请及时关注作物生长" },
                { deviceName: "水质5（二期）", warnTime: "2024-06-12", content: "污泥浓度过高，请及时处理" },
            ],
        }
    },
    created() {
    },
    mounted() {
        const table = this.$refs.table
        this.scrollFun(table)
    },
    methods: {
        scrollFun(ref) {
            window.clearInterval(this.timer)
            const divData = ref.bodyWrapper
            this.timer = setInterval(() => {
                divData.scrollTop += 1;
                if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
                    divData.scrollTop = 0
                }
            }, 50)
        },

        enter() {
            window.clearInterval(this.timer)
        },

        leave() {
            const table = this.$refs.table
            this.scrollFun(table)
        },
    },
}
</script>
<style lang="less" scoped>
.device-warning {
    margin-top: 20px;

    .table-wrap {
        width: 100%;
        // height: 100%;
        padding: 0 10px 0 30px;
        height: 240px;
        box-sizing: border-box;

        // 修改滚动条样式
        ::-webkit-scrollbar {
            width: 2px;
        }

        ::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: rgba(22, 138, 130, 0.82);
        }

        ::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            border-radius: 0;
            background: rgba(26, 120, 114, 0.28);
        }
    }
}
</style>
